import { useI18n } from "@/locales/i18n-provider";

const en = {
  project: "Project",
  category: "Ticket category",
  subcategory: "Subcategory",
  categoryPlaceholder: "Select a category",
  categoryLeafRequired: "Select a category with no subcategories.",
  categoryUnavailable: "This category is unavailable. Refresh the categories and select again.",
  commonCategories: "General categories",
  projectCategories: "Project categories",
  chooseProject: "Select a project",
  source: "Customer source",
  local: "Tickbird customers",
  customer: "Customer",
  order: "Order",
  search: "Search",
  searchHint: "Search by customer NRC, phone or name",
  zamloanCustomerSearch: "Enter NRC (123456/78/1); phone optional",
  select: "Select…",
  none: "None",
  selected: "Selected",
  subject: "Ticket title",
  subjectPlaceholder: "Summarize the issue in one sentence",
  body: "Description",
  bodyPlaceholder: "Describe what happened, its impact and the help you need",
  ticketInformation: "Ticket information",
  customerInformation: "Customer & contact",
  customerDetails: "Customer information",
  findSystemMember: "Find member",
  member: "Member",
  memberRequiredHint: "Find the system member for this ticket to fill in their contact details.",
  unlinkCustomer: "Unlink customer",
  customerLookupHint: "Find and select a system member to fill in their contact and order information.",
  cancel: "Cancel",
  leaveTitle: "Discard this ticket?",
  leaveDescription: "This ticket has not been created. Leaving this page will discard your changes.",
  keepEditing: "Keep editing",
  discardAndLeave: "Discard and leave",
  customerHint: "Select a customer to fill in their contact details. You can also enter them below.",
  customerRequiredHint: "Select the customer for this ticket. Their contact details will be filled in below.",
  contactHint: "Contact details can be updated for this ticket.",
  businessHint: "Complete the details for the selected category.",
  pageDescription: "Choose a category and describe the issue to get started.",
  requiredHint: "Fields marked * are required",
  processing: "Processing…",
  name: "Contact name",
  phone: "Phone",
  email: "Email",
  business: "Additional information",
  attachments: "Attachments",
  upload: "Add files",
  remove: "Remove",
  submit: "Create ticket",
  submitting: "Creating…",
  loading: "Loading…",
  retry: "Retry",
  required: "This field is required",
  number: "Enter a valid number",
  range: "Value is outside the allowed range",
  length: "Text length is outside the allowed range",
  scale: "Too many decimal places",
  noResults: "No results",
  moreResults: "More results are available. Refine your search.",
  error: "The request failed. Your input has been kept; try again.",
  unavailable: "The business integration is not configured. Ask your administrator to configure it before using this lookup.",
  versionConflict: "The form has changed. Reload the current form to continue; compatible input will be kept.",
  reloadForm: "Reload form",
  recovered: "The current form is loaded. Review your input before submitting.",
  scanPending: "Scanning",
  scanClean: "Ready",
  scanRejected: "Rejected",
  scanHint: "Add screenshots or supporting files. Files must pass scanning before the ticket can be created.",
  refreshScan: "Refresh file status",
  notAllowed: "You do not have permission to create tickets.",
  noProjects: "No projects are available for creating tickets.",
  start: "Select a project to start creating a ticket.",
  preparingProject: "Preparing the ticket creation page…",
  projectLoadFailed: "The host's project could not be confirmed. Please retry.",
  projectUnavailable: "The host's project does not exist or you do not have permission to create tickets in it.",
  projectAmbiguous: "The host's project code matches multiple projects. Ask your administrator to correct the configuration.",
  projectStartFailed: "The ticket creation page could not be initialized for the host's project. Please retry.",
  submitHint: "You can follow up on the ticket after it is created.",
  clear: "Clear",
  contextHint: "Information from the current workspace has been included.",
  dirtyClose: "You have unsaved changes. Close this form?",
  yes: "Yes",
  no: "No",
};
const zh: typeof en = {
  project: "项目",
  category: "工单分类",
  subcategory: "子分类",
  categoryPlaceholder: "请选择工单分类",
  categoryLeafRequired: "请选择最末级分类。",
  categoryUnavailable: "该分类暂不可用，请刷新分类后重新选择。",
  commonCategories: "通用分类",
  projectCategories: "项目分类",
  chooseProject: "请选择项目",
  source: "客户来源",
  local: "Tickbird 客户",
  customer: "客户",
  order: "订单",
  search: "查询",
  searchHint: "输入客户 NRC、手机号或姓名",
  zamloanCustomerSearch: "输入 NRC（123456/78/1），手机号可选",
  select: "请选择…",
  none: "无",
  selected: "已选择",
  subject: "工单标题",
  subjectPlaceholder: "请输入工单标题",
  body: "问题描述",
  bodyPlaceholder: "请填写问题详情及处理诉求",
  ticketInformation: "工单信息",
  customerInformation: "客户与联系信息",
  customerDetails: "客户信息",
  findSystemMember: "查找用户",
  member: "Member",
  memberRequiredHint: "此分类需关联用户。",
  unlinkCustomer: "取消关联客户",
  customerLookupHint: "选择用户后，自动填入联系人及订单信息。",
  cancel: "取消",
  leaveTitle: "放弃创建工单？",
  leaveDescription: "当前工单尚未创建，离开后将丢失已填写的内容。",
  keepEditing: "继续编辑",
  discardAndLeave: "放弃并离开",
  customerHint: "选择客户可带入联系信息，也可直接填写下方信息。",
  customerRequiredHint: "请先选择本次工单的客户，联系信息会自动带入。",
  contactHint: "可按本次工单需要调整联系信息。",
  businessHint: "请补充所选分类需要的信息。",
  pageDescription: "选择工单分类，描述需要处理的问题。",
  requiredHint: "带 * 的为必填项",
  processing: "处理中…",
  name: "联系人姓名",
  phone: "手机号",
  email: "邮箱",
  business: "补充信息",
  attachments: "附件",
  upload: "添加附件",
  remove: "移除",
  submit: "创建工单",
  submitting: "正在创建…",
  loading: "正在加载…",
  retry: "重试",
  required: "此项为必填",
  number: "请输入有效数字",
  range: "数值超出允许范围",
  length: "文本长度超出允许范围",
  scale: "小数位数超出限制",
  noResults: "没有查询结果",
  moreResults: "还有更多结果，请缩小查询范围。",
  error: "请求失败，已保留输入内容，请重试。",
  unavailable: "业务集成尚未配置，请联系管理员完成后再使用此查询。",
  versionConflict: "表单已更新，请重新加载当前表单；兼容的输入内容将会保留。",
  reloadForm: "更新表单",
  recovered: "已加载当前表单，请检查输入内容后再提交。",
  scanPending: "扫描中",
  scanClean: "可提交",
  scanRejected: "未通过扫描",
  scanHint: "附件须通过安全扫描后方可提交。",
  refreshScan: "刷新附件状态",
  notAllowed: "你没有创建工单的权限。",
  noProjects: "没有可供创建工单的项目。",
  start: "请选择项目开始创建工单。",
  preparingProject: "正在加载创建工单页面…",
  projectLoadFailed: "无法确认宿主指定的项目，请重试。",
  projectUnavailable: "宿主指定的项目不存在，或你没有在该项目创建工单的权限。",
  projectAmbiguous: "宿主指定的项目编码对应多个项目，请联系管理员修正配置。",
  projectStartFailed: "无法初始化宿主指定项目的工单页面，请重试。",
  submitHint: "创建后可在工单详情中跟进处理。",
  clear: "清除",
  contextHint: "已带入当前工作台的业务信息。",
  dirtyClose: "存在未保存的内容，确定关闭表单吗？",
  yes: "是",
  no: "否",
};
export function useIntakeMessages() {
  const { locale } = useI18n();
  return locale === "zh-Hans" ? zh : en;
}
